import { render, staticRenderFns } from "./hqglLogisticsFix.vue?vue&type=template&id=729c48fb&scoped=true&"
import script from "./hqglLogisticsFix.vue?vue&type=script&lang=js&"
export * from "./hqglLogisticsFix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729c48fb",
  null
  
)

export default component.exports